import React from 'react'
import { Card, ListGroup, Button } from 'react-bootstrap'
import { FaCheck } from "react-icons/fa"
import classnames from 'classnames'

import * as PricingConstants from './../helpers/constant'

import contactUsImage from './../../../images/contact.png'

const EnterpriseCard = ({ isBestValue, isCustom }) => {

  const plan = PricingConstants.ENTERPRISE_CARD_DATA
  const handleContactUs = () => {
    window.open('/contact-us/', '_self')
  }

  return (
    <Card className={classnames("pricing-card", { "card-tag": isBestValue || isCustom })} >
      {
        isBestValue || isCustom
          ? <div className={classnames({ "card-tag__best-value": isBestValue || isCustom })}>
            {isBestValue ? 'Best Value' : ''}
            {isCustom ? 'Custom' : ''}
          </div>
          : null
      }
      <Card.Header className='pricing-card__header enterprise-card_header' >
        <div className='header-title'>
          <div className='plan-name'>{plan.short_name}</div>
          <div className='header-subtitle'>
            {plan.tagline}
          </div>
        </div>
        <div className='contact-us-img'>
          <img
            src={contactUsImage}
            alt='contact-us'
            height={30}
            width={30}
          />
        </div>
        <Button
          variant='outline-secondary'
          className='purchase-btn-text'
          onClick={handleContactUs}
        >
          Contact Us
        </Button>
      </Card.Header >
      <ListGroup>
        {plan.features.map((feature, index) => (
          <ListGroup.Item key={index}>
            <div className='feature-icon-container'>
              <FaCheck size={'100%'} />
            </div>
            {feature.description}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card >
  )
}

export default EnterpriseCard